
export const constants = {
    finalyze: '/finalyze',
}

export const navBarList = [
    { name: 'Company Essential', id: 'company_essential' },
    { name: 'Pros & Cons', id: 'pros_cons' },
    { name: 'P&L', id: 'profit_loss_yearly' },
    { name: 'Quarterly', id: 'profit_loss_quarterly' },
    { name: 'Balance sheet', id: 'balance_sheet' },
    { name: 'Cash Flow', id: 'cash_flow' },
    { name: 'Chart', id: 'charts' },
    { name: 'Brands', id: 'brands' },
    { name: 'Peer', id: 'peer_comparison' },
    { name: 'Ratios', id: 'ratio' },
    { name: 'Du pont', id: 'dupont' },
    { name: 'Fair Value', id: 'analysis' }
]

export const prefixandsupfix = {
    market_cap: { prefix: '₹', supfix: 'Cr.' },
    enterprise_value: { prefix: '₹', supfix: 'Cr.' },
    number_of_share: { prefix: '', supfix: 'Cr.' },
    price_to_earning_ratio: { prefix: '', supfix: '' },
    price_to_book_value: { prefix: '', supfix: '' },
    face_value: { prefix: '₹', supfix: '' },
    dividend_yield: { prefix: '', supfix: '%' },
    book_value: { prefix: '₹', supfix: '' },
    cash: { prefix: '₹', supfix: 'Cr.' },
    debt: { prefix: '₹', supfix: 'Cr.' },
    promoter_holding: { prefix: '', supfix: '%' },
    eps: { prefix: '₹', supfix: '' },
    sales_growth: { prefix: '', supfix: '%' },
    roe: { prefix: '', supfix: '%', dupont_supfix: '(%)' },
    roce: { prefix: '', supfix: '%' },
    profit_growth: { prefix: '', supfix: '%' },
    profitability: { prefix: '', supfix: '(%)' },
    productivity: { prefix: '', supfix: '(X)' },
    leverage: { prefix: '', supfix: '(X)' },
}

export const prefixandsupfix_dupont = {
    roe: { prefix: '', supfix: '(%)' },
    profitability: { prefix: '', supfix: '(%)' },
    productivity: { prefix: '', supfix: '(X)' },
    leverage: { prefix: '', supfix: '(X)' }

}

export const textBold = {
    net_profit: { fontWeight: 'bold' },
    total_assets: { fontWeight: 'bold' },
    net_cash_flow: { fontWeight: 'bold' },
    total_liabilities: { fontWeight: 'bold' },
    profit_before_tax: { fontWeight: 'bold' },
    operating_profit: { fontWeight: 'bold' },
}

export const tdTextSupfix = {
    roe: { supfix: '(%)' },
    roce: { supfix: '(%)' },
    opm: { supfix: '(%)' },
    // tax: { supfix: '(%)' },
    profitability: { supfix: '(%)' },
    dividend_payout: { supfix: '(%)' },
}